var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDensityStandard(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5 9C5 8.44772 5.44772 8 6 8H18C18.5523 8 19 8.44772 19 9V9C19 9.55228 18.5523 10 18 10H6C5.44772 10 5 9.55228 5 9V9Z",
    className: "fill"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5 12C5 11.4477 5.44772 11 6 11H18C18.5523 11 19 11.4477 19 12V12C19 12.5523 18.5523 13 18 13H6C5.44772 13 5 12.5523 5 12V12Z",
    className: "fill"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5 15C5 14.4477 5.44772 14 6 14H18C18.5523 14 19 14.4477 19 15V15C19 15.5523 18.5523 16 18 16H6C5.44772 16 5 15.5523 5 15V15Z",
    className: "fill"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDensityStandard);
export default __webpack_public_path__ + "static/media/density-standard.c81876f0bc519682f8ff33aca8e1caa9.svg";
export { ForwardRef as ReactComponent };